// extracted by mini-css-extract-plugin
export var avatarContainer = "_fo-0";
export var gray = "_fo-f";
export var green = "_fo-c";
export var icon = "_fo-9";
export var image = "_fo-1";
export var lg = "_fo-6";
export var md = "_fo-5";
export var presenceDot = "_fo-b";
export var red = "_fo-d";
export var sm = "_fo-4";
export var status = "_fo-a";
export var xl = "_fo-7";
export var xs = "_fo-3";
export var xxl = "_fo-8";
export var xxs = "_fo-2";
export var yellow = "_fo-e";